import {computed, Signal} from '@angular/core';
import {FieldType} from '@core/api/data-access';
import {ISignField} from '@global-data';

import {CheckBoxSignFieldModel, SignFieldModel} from '../../models';
import {SignService} from '../sign.service';

export class SignFieldsInspectorService {
	/* ------------------------------------------------  Signals ------------------------------------------------ */

	private readonly activeFieldIndex: Signal<number> = computed(() => this.signService.Fields.activeField()?.index || NaN);
	private readonly fillableFields: Signal<ISignField[]> = computed(() => {
		const fields = this.signService.Fields.fields().filter(
			field => (!SignFieldModel.isExternalField(field.type) && !field.signalFC.value()) || (field.type === FieldType.checkBox && !(field as CheckBoxSignFieldModel).checked()),
		);
		return fields.sort((a, b) => {
			if (a.settings$()?.Ordinal && b.settings$()?.Ordinal) return a.settings$().Ordinal - b.settings$().Ordinal;
			return a.page - b.page;
		});
	});

	/* ------------------------------------------------  Constructor ------------------------------------------------ */
	constructor(private signService: SignService) {}

	/* --------------------------------------------- PUBLIC METHODS --------------------------------------------- */

	public previousField(): void {
		const fillableFields = this.fillableFields();
		if (!fillableFields?.length) return;

		const activeFieldIndex = this.activeFieldIndex();
		if (isNaN(activeFieldIndex)) {
			// אם אין שדה פעיל, נתחיל מהשדה האחרון
			this.signService.Fields.activeField.set(fillableFields[fillableFields.length - 1] as SignFieldModel);
			return;
		}

		const currentFieldIndex = fillableFields.findIndex(field => field.index === activeFieldIndex);
		const nextIndex = currentFieldIndex === 0 ? fillableFields.length - 1 : currentFieldIndex - 1;
		this.signService.Fields.activeField.set(fillableFields[nextIndex] as SignFieldModel);
	}

	public nextField(): void {
		const fillableFields = this.fillableFields();
		if (!fillableFields?.length) return;

		const activeFieldIndex = this.activeFieldIndex();
		if (isNaN(activeFieldIndex)) {
			// אם אין שדה פעיל, נתחיל מהשדה הראשון
			this.signService.Fields.activeField.set(fillableFields[0] as SignFieldModel);
			return;
		}

		const currentFieldIndex = fillableFields.findIndex(field => field.index === activeFieldIndex);
		const nextIndex = currentFieldIndex === fillableFields.length - 1 ? 0 : currentFieldIndex + 1;
		this.signService.Fields.activeField.set(fillableFields[nextIndex] as SignFieldModel);
	}
}
